export const PortugueseRoutes = {
  Home: {
    URL: 'pt',
  },
  Register: {
    URL: 'pt/registo',
  },
  RegisterWithPromotion: {
    URL: 'pt/registo/:promotion',
  },
  Login: {
    URL: 'pt/login',
  },
  Contact: {
    URL: 'pt/contacto',
  },
  TermsOfUse: {
    URL: 'pt/termos',
  },
  Cookies: {
    URL: 'pt/cookies',
  },
  Privacy: {
    URL: 'pt/privacidade',
  },
  Hiring: {
    URL: 'pt/condicoes',
  },
  HiringWithRate: {
    URL: 'pt/condicoes/:rate',
  },
  'android-login': {
    URL: 'pt/android-login',
  },
  'android-register': {
    URL: 'pt/android-register',
  },
  Platform: {
    URL: 'plataforma',
  },
};
